import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import I18n from '../i18n';

export default function List(props) {
  const {
    searchable,
    searchPlaceholder,
    label,
    showDescriptions,
    className,
    items,
    selectedValue,
    onChange,
    onSearch,
    ...rest
  } = props;

  const _onSearch = React.useCallback(changeEvent => {
    if (onSearch) {
      onSearch(changeEvent.target.value);
    }
  });

  function renderItem(item) {
    const {name, description, value} = item;

    return (
      <li
        key={value}
        onClick={onChange.bind(undefined, value)}
        className={classNames(
          'suggestion',
          showDescriptions ? null : 'no-description',
          item.value === selectedValue ? 'selected' : null,
        )}
      >
        <span className="name">{name}</span>
        {showDescriptions && (
          <>
            <br />
            <span className="description">&nbsp;{description}</span>
          </>
        )}
      </li>
    );
  }

  return (
    <div className={classNames('selection-list', className)} {...rest}>
      {searchable && (
        <div className="search">
          <input type="search" className="form-control" placeholder={I18n.t(searchPlaceholder)} onChange={_onSearch} />
        </div>
      )}
      {label && <p>{label}</p>}
      <ul>{items && items.map(renderItem)}</ul>
    </div>
  );
}

List.defaultProps = {
  searchable: true,
  showDescriptions: true,
};

List.propTypes = {
  /** Whether or not a search box should be rendered for this list. */
  searchable: PropTypes.bool,
  /** Optional i18n key to override the placeholder text shown in the search box. */
  searchPlaceholder: PropTypes.string,
  /** A text description to show above the list. If not specified, no label will be shown. */
  label: PropTypes.string,
  /** An optional class name to add to the HTML element. */
  className: PropTypes.string,
  /** An array of items to render, of the form {name, description, value} */
  items: PropTypes.array.isRequired,
  /** Whether or not the descriptions should be shown. */
  showDescriptions: PropTypes.bool,
  /** The currently selected value. */
  selectedValue: PropTypes.any,
  /** A callback to execute when the selection changes. Passes the selected value. */
  onChange: PropTypes.func.isRequired,
  /** A callback to execute when the search input changes. Required if searchable is true. */
  onSearch: PropTypes.func,
};
